import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import AtomButton, {atomButtonDesigns, atomButtonShapes} from '@s-ui/react-atom-button'
import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import AtomImage from '@s-ui/react-atom-image'
import {
  MoleculeDrawer,
  MoleculeDrawerOverlay,
  moleculeDrawerPlacements,
  moleculeDrawerSizes
} from '@s-ui/react-molecule-drawer'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

const BASE_CLASS = 'mt-MyAds-infoDrawer'

const InfoDrawer = ({
  contentTitle,
  ctaHref,
  ctaLabel,
  ctaTarget,
  description,
  illustrationUrl,
  isOpen,
  onClose,
  title
}) => {
  return (
    <>
      <MoleculeDrawerOverlay isVisible={isOpen} onClick={onClose} />
      <MoleculeDrawer
        closeOnOutsideClick
        isOpen={isOpen}
        onClose={onClose}
        placement={moleculeDrawerPlacements.RIGHT}
        size={moleculeDrawerSizes.AUTO}
      >
        {isOpen && (
          <div className={BASE_CLASS}>
            <div className={`${BASE_CLASS}-header`}>
              <TitleBasic as={titleBasicTags.h2} size={titleBasicSizes.xss} title={title} />
              <AtomButton
                design={atomButtonDesigns.FLAT}
                leftIcon={<IconClose size={ATOM_ICON_SIZES.medium} />}
                onClick={onClose}
              />
            </div>
            <div className={`${BASE_CLASS}-content`}>
              <div className={`${BASE_CLASS}-image`}>
                <AtomImage alt="" src={illustrationUrl} />
              </div>
              {contentTitle && <TitleBasic as={titleBasicTags.h3} size={titleBasicSizes.s} title={contentTitle} />}
              {description && <p className={`${BASE_CLASS}-description`}>{htmlStringToReactElement(description)}</p>}
              {ctaLabel && ctaHref && (
                <div className={`${BASE_CLASS}-ctaWrapper`}>
                  <AtomButton
                    design={atomButtonDesigns.SOLID}
                    fullWidth
                    href={ctaHref}
                    link
                    rel={ctaTarget === '_blank' ? 'noopener noreferrer' : undefined}
                    shape={atomButtonShapes.CIRCULAR}
                    target={ctaTarget}
                  >
                    <span className={`${BASE_CLASS}-ctaLabel`}>{ctaLabel}</span>
                  </AtomButton>
                </div>
              )}
            </div>
          </div>
        )}
      </MoleculeDrawer>
    </>
  )
}

InfoDrawer.displayName = 'InfoDrawer'

InfoDrawer.propTypes = {
  contentTitle: PropTypes.string,
  ctaHref: PropTypes.string,
  ctaLabel: PropTypes.string,
  ctaTarget: PropTypes.string,
  description: PropTypes.string,
  illustrationUrl: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
}

export default InfoDrawer
